import API from "./api";

// Get all applications (Admin)
export const getAllApplications = async (params = {}) => {
  try {
    const response = await API.get("/applications/all", { params });
    return response.data?.data ?? [];
  } catch (error) {
    // Backward compatibility for backend versions exposing /applications/admin
    if (error?.response?.status === 404) {
      const fallbackResponse = await API.get("/applications/admin", { params });
      return fallbackResponse.data?.data ?? [];
    }
    throw error;
  }
};

// Quick filter applications by status
export const filterApplications = async (status) => {
  const response = await API.get("/applications/filter", {
    params: { status },
  });
  return response.data?.data ?? [];
};

// Update application status
export const updateApplicationStatus = async (applicationId, status) => {
  const response = await API.put(`/applications/${applicationId}/status`, {
    status,
  });
  return response.data;
};

// Shortlist candidate
export const shortlistCandidate = async (applicationId) => {
  const response = await API.patch(
    `/applications/${applicationId}/shortlist`
  );
  return response.data;
};

// Schedule interview
export const scheduleInterview = async (applicationId, data) => {
  const response = await API.post(
    `/applications/${applicationId}/schedule-interview`,
    data
  );
  return response.data;
};

